import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../API/API";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTelegram,
  faTelegramPlane,
  faTiktok,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import "./Socialmadia.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

export default function SocialMadia() {
  const [supportPhone, setSupportPhone] = useState("01031360031");

  useEffect(() => {
    axios.get(`${baseURL}/learning/settings`)
      .then(res => {
        if (res.data?.data?.support_phone) {
          setSupportPhone(res.data.data.support_phone);
        }
      })
      .catch(err => console.log(err));
  }, []);

  return (
    <>
      <div className="social-media">
        <div className="social-links">
          <a
            className="facebook"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/share/1AtvUxo7Ke/"
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a
            className="youtube"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/@nouhacadeemy"
          >
            <FontAwesomeIcon icon={faYoutube} />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="tictok"
            href="https://www.tiktok.com/@nooh_2021?_t=ZS-8yNiT9rbRx9&_r=1"
          >
            <FontAwesomeIcon icon={faTiktok} />
          </a>
          <a className="email" href="mailto:nouhacadeemy@gmail.com">
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
        </div>
      </div>

      <div className="socal-order">
        <div className="socal">
          <a className="chat" target="_blank" rel="noopener noreferrer" href="https://t.me/nouh2026">
            <FontAwesomeIcon icon={faTelegram} />
          </a>
          <a
            className="whats-app"
            target="_blank"
            rel="noopener noreferrer"
            href={`https://wa.me/${supportPhone.replace(/[\s\-\+]/g, "").replace(/^0/, "20").replace(/^1/, "201")}`}
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
        </div>
      </div>
    </>
  );
}
